/* global Splide */

const initSideCartPromoUpsell = () => {
  const initPromoUpsellSlider = () => {
    const el = document.querySelector(".side-cart-promo-upsell.side-cart-promo-upsell--carousel .splide");
    if (!el) return;

    const promoSplide = new Splide(el, {
      type: "slide",
      arrows: false,
      pagination: false,
      perPage: 1.3,
      perMove: 1,
      gap: 16,
      drag: true,
      focus: 0,
      breakpoints: {
        500: {
          perPage: 1.2,
          gap: 9,
        },
      },
    });

    const bar = promoSplide.root.querySelector(".side-cart-promo-upsell__progress-bar");
    const barContainer =promoSplide.root.querySelector(".side-cart-promo-upsell__progress");

    // Updates the bar width whenever the carousel moves:
    promoSplide.on("mounted move", function () {
      const end = promoSplide.Components.Controller.getEnd() + 1;
      const rate =Math.min((promoSplide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";
    });

    promoSplide.mount();

    barContainer.setAttribute("count", promoSplide.Components.Slides.getLength());

    window.sideCartInstance.initializeAddToCartFormsPartial(el);
  };

  const cartDrawer = document.querySelector("side-cart");

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains("open")) {
        setTimeout(() => {
          initPromoUpsellSlider();
        }, 200);
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
};

export { initSideCartPromoUpsell };
